import { gql } from '@apollo/client';

export const GET_ADMIN_ACCESS = gql`
  query GetAdminAccess {
    adminAccess
  }
`;

export const GET_ADMIN_OVERVIEW = gql`
  query GetAdminOverview {
    adminOverview {
      upcomingBookings
      pendingRequests
      completedThisMonth
      completedLastMonthToDate
      revenueThisMonthCents
      platformFeeThisMonthCents
      platformFeeLastMonthToDateCents
      newClientsThisMonth
      newClientsLastMonthToDate
      listedStylists
      bookableStylists
      unopenedConversations
      staleUnopenedConversations
      weeks {
        weekStart
        completed
        platformFeeCents
        newClients
      }
    }
  }
`;

export const GET_ADMIN_STYLISTS = gql`
  query GetAdminStylists {
    adminStylists {
      stylistId
      userId
      name
      email
      city
      address {
        id
        streetAddress
        city
        state
        zipCode
        country
        locationType
        accessDetails
      }
      isAvailableInPerson
      customHourlyRate
      customInPersonHourlyRate
      tierHourlyRate
      profilePicUrl
      isTestUser
      status
      hasCalendar
      calendarNeedsReconnect
      calendar
      timezone
      shareCode
      upcomingDaysWithHours
      nextDateWithHours
      lastSeenAt
      instantStylingActive
      upcomingSessions
      completedSessions
    }
  }
`;

export const GET_ADMIN_CONVERSATIONS = gql`
  query GetAdminConversations {
    adminConversations {
      channelUrl
      lastMessageAt
      recipient {
        userId
        name
        email
        type
      }
      sender {
        userId
        name
        email
        type
      }
    }
  }
`;

export const GET_ADMIN_BOOKINGS = gql`
  query GetAdminBookings($filter: AdminBookingFilter!) {
    adminBookings(filter: $filter) {
      id
      startTime
      status
      sessionType
      isInstant
      estimatedDuration
      clientName
      stylistName
      isTest
      authorizedCents
      capturedCents
      paymentStatus
      discountCode
      discountPercentage
    }
  }
`;

export const GET_ADMIN_DISCOUNT_CODES = gql`
  query GetAdminDiscountCodes {
    adminDiscountCodes {
      id
      codeText
      discountPercentage
      expiresAt
      isActive
      stylistName
      timesUsed
      timesPaid
      createdAt
    }
  }
`;

export const ADMIN_CREATE_DISCOUNT_CODE = gql`
  mutation AdminCreateDiscountCode($input: AdminCreateDiscountCodeInput!) {
    adminCreateDiscountCode(input: $input) {
      id
    }
  }
`;

export const ADMIN_SET_DISCOUNT_CODE_ACTIVE = gql`
  mutation AdminSetDiscountCodeActive($id: Int!, $isActive: Boolean!) {
    adminSetDiscountCodeActive(id: $id, isActive: $isActive)
  }
`;

export const GET_ADMIN_USERS = gql`
  query GetAdminUsers(
    $search: String
    $type: UserType
    $days: Int
    $allTime: Boolean
    $includeTestUsers: Boolean
  ) {
    adminUsers(
      search: $search
      type: $type
      days: $days
      allTime: $allTime
      includeTestUsers: $includeTestUsers
    ) {
      totalCount
      clientCount
      stylistCount
      users {
        userId
        name
        email
        type
        isTestUser
        createdAt
        profilePicUrl
        city
        lastSeenAt
        completedSessions
        setupComplete
      }
    }
  }
`;

export const ADMIN_SET_TEST_USER = gql`
  mutation AdminSetTestUser($userId: Int!, $isTestUser: Boolean!) {
    adminSetTestUser(userId: $userId, isTestUser: $isTestUser)
  }
`;

export const ADMIN_UPDATE_STYLIST_BOOKING = gql`
  mutation AdminUpdateStylistBooking(
    $stylistId: Int!
    $input: AdminStylistBookingInput!
  ) {
    adminUpdateStylistBooking(stylistId: $stylistId, input: $input)
  }
`;
